import ColumnsContent from 'components/Hocs/ColumnsContent';
import groupsSearchCollector from 'components/Hocs/GroupsSearchNewCollector';

import MyUsersBlackList from './MyUsersBlackList';

export default ColumnsContent(groupsSearchCollector(MyUsersBlackList));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/MyUsersBlackList/index.js